var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-height"},[_c('el-header',{staticClass:"main-head"},[_c('img',{staticClass:"user-icon",attrs:{"src":require("../assets/me_center.svg"),"alt":""}}),_vm._v(" 个人中心 ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }